import { Alert, AlertTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'

const NW_SITE_UUIDS = [
  '4c1f6be9-f795-4529-8f20-a81ca5c75cbf', // NW production
  'c7cc280c-8ff9-45dc-88f7-f4509f63998d', // NW staging
]

type SiteRevenueDisclaimerProps = {
  siteUuid: string
}

export function SiteRevenueDisclaimer({ siteUuid }: Readonly<SiteRevenueDisclaimerProps>) {
  const { t } = useTranslation()

  if (NW_SITE_UUIDS.includes(siteUuid)) {
    return null
  }

  return (
    <Alert severity="info">
      <AlertTitle>{t('customer_revenue.disclaimer.title')}</AlertTitle>
      {t('customer_revenue.disclaimer.description')}
    </Alert>
  )
}
